<template>
  <z-card-modal width="400px" :opened="opened">
    <template #content>
      <div class="container">
        <div ref="photoContainer" class="photo-container">
          <z-photo-upload
            ref="photoUploader"
            class="photo-uploader"
            :rounded="rounded"
            :image="img"
            @change="onSelectImage"
          />
        </div>
        <z-slider
          v-model="value"
          class="mt-4"
          :append-icon="appendIcon"
          :prepend-icon="prependIcon"
          :min="min"
          :max="max"
          @click:append="onAdd"
          @click:prepend="onDecrease"
          @change="onChange"
        ></z-slider>
        <!--@slot Slot para customizar os botões do componente -->
        <slot name="btns">
          <div class="btn-container">
            <!--Evento emitdo ao fechar a modal
                @event close
                @property {Boolean} false - Indica se a modal deve ser fechada
             -->
            <z-btn
              secondary
              :text="$t('cancel')"
              @click="$emit('close', false)"
            ></z-btn>
            <z-btn primary :text="$t('save_changes')" @click="onSave"></z-btn>
          </div>
        </slot>
      </div>
    </template>
  </z-card-modal>
</template>

<script>
import debounce from 'lodash.debounce'

/**
 * @displayName User Photo Modal
 */
export default {
  name: 'ZUserPhotoModal',
  props: {
    /**
     * Define se o modal está aberto ou fechado
     */
    opened: {
      type: Boolean,
      required: true,
    },
    /**
     * Aplica o estilo rouded ao cropper de image,
     */
    rounded: {
      type: Boolean,
      default: false,
    },
    /**
     * Define o ícone do append do slider
     */
    appendIcon: {
      type: String,
      default: '$add_rounded',
    },
    /**
     * Define o ícone do prepend do slider
     */
    prependIcon: {
      type: String,
      default: '$remove_rounded',
    },
  },
  data() {
    return {
      value: 300,
      img: null,
      min: 0,
      max: 350,
    }
  },
  watch: {
    opened(isOpened) {
      if (isOpened) {
        this.img = null
      }
    },
  },
  methods: {
    onAdd() {
      this.value += 0.1 * this.max

      if (this.value >= this.max) {
        this.value = this.max
      }
      this.$refs.photoUploader.setCropBoxData({
        height: this.value,
        width: this.value,
      })
    },
    onDecrease() {
      this.value -= 0.1 * this.max

      if (this.value <= this.min) {
        this.value = this.min
      }
      this.$refs.photoUploader.setCropBoxData({
        height: this.value,
        width: this.value,
      })
    },
    onChange: debounce(function (value) {
      this.value = value
      this.$refs.photoUploader.setCropBoxData({
        height: this.value,
        width: this.value,
      })
    }, 200),
    onSave() {
      const image = this.$refs.photoUploader.getCroppedImage()
      /**
       * Evento emitido quando o usuário salva a imagem
       *
       * @property {String} image Imagem salva
       */
      this.$emit('click:save', image)
    },
    onSelectImage(image) {
      this.img = image
      setTimeout(() => {
        const height = this.$refs.photoContainer.clientHeight
        const width = this.$refs.photoContainer.clientWidth
        const max = height > width ? width : height

        this.max = max
        this.$refs.photoUploader.setCropBoxData({
          height: this.max * 0.8,
          width: this.max * 0.8,
        })
      }, 500)
    },
  },
  i18n: {
    messages: {
      pt: {
        save_changes: 'Salvar alterações',
        cancel: 'Cancelar',
      },
      es: {
        save_changes: 'Salvar alterações',
        cancel: 'Cancelar',
      },
      en: {
        save_changes: 'Save changes',
        cancel: 'Cancel',
      },
      fr: {
        save_changes: 'Enregistrer les modifications',
        cancel: 'Annuler',
      },
      tr: {
        save_changes: 'Değişiklikleri Kaydet',
        cancel: 'İptal',
      },
    },
  },
}
</script>

<style scoped lang="scss">
.photo-uploader {
  max-width: 350px;
}

span {
  text-align: center;
  width: 100%;
  display: block;
}

.container {
  display: grid;
  align-items: flex-end;
  grid-template-rows: 1fr auto;
}

.btn-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-width: 100%;
  gap: 10px;
}

@media only screen and (max-width: 425px) {
  .btn-container {
    flex-direction: column-reverse;
  }
}
</style>
